import React from 'react';
import { withRouter } from "react-router-dom";
import { logUI } from '../../api/andyliticsApi';
import { isCentralTimeZone, getCurDateInCentralTz, getCentralDateWithFormat, getURLPath, trimComma, toJSDate, getMomentFormattedDate, dateStringFormat } from "../../helpers/Tools";
import MiniSpinner from "../common/MiniSpinner";
import { Thumbnail, Typography } from '../ecosystem';
import VideoVisitProviderCard from './VideoVisitProviderCard';


class VideoVisitAvailability extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { type } = this.props;
        logUI(`MBHWeb.UI.VideoVisitAvailability.${type === "FINDNEWDOCTOR" ? "FindNewDoctor" : type === "ONCALLPROVIDER" ? "OnCallProvider" : "YourDoctor"}.ComponentDidMount`, new Date(), getURLPath());
    }

    scheduleAppointment(e, item, isMoreButton=false) {
        const { type, isFromVideoVisitOptions } = this.props;
        let npiId = ""; 
        if (item &&  item.provider && item.provider.iDs) {
            for (let ids of item.provider.iDs) {
                for (let id in ids) {
                    if (ids.type === "ProviderNPI") {
                        npiId = ids.id;
                    }
                        
                }
            }
        }
        
        logUI(`MBHWeb.UI.VideoVisitAvailability.${type === "FINDNEWDOCTOR" ? "FindNewDoctor" : type === "ONCALLPROVIDER" ? "OnCallProvider" : "YourDoctor"}.OnButtonClick`, new Date(), getURLPath(), JSON.stringify(item));
        if (type === "YOURDOCTOR")
            this.props.history.push({
                pathname: `/schedule/${npiId}/DirectSchedule`,
                state: {
                    selectedUser: this.props.selectedUser, noSelectPatient: this.props.noSelectPatient,
                    scheduleType: "DirectSchedule", isFromVideoVisitOptions: isFromVideoVisitOptions,
                    isMyDoctor: true
                }
            });  
        if (type === "FINDNEWDOCTOR")
            this.props.history.push({
                pathname: `/schedule/${npiId ? npiId : item.provider.npi}/OpenSchedule`,
                state: { selectedUser: this.props.selectedUser, noSelectPatient: this.props.noSelectPatient, isFromVideoVisitOptions: isFromVideoVisitOptions, isLocalDoctor: true }
            });
        
        if (type === "ONCALLPROVIDER") 
            this.props.history.push({
                pathname: item.redirectTo,
                state: { selectedTimeSlot: item.timeSlot, selectedDay: item.selectedDay, isFromVideoVisitOptions: isFromVideoVisitOptions }
            });
        
    }
    getProviderSlots=(scheduleDays)=>{
        let slots=scheduleDays.map((scheduleDay)=>dateStringFormat(scheduleDay.date,"MM/DD")).slice(0,2);
        var stringSlots=slots.join("  |  "); 
        return stringSlots;
       }
    render() {
        const { type, providers, data, displayName, specialty, avatar, disabled, error, errorMsg, showMiniSpinner,
            hasMoreButton, showTimeZoneMessage } = this.props;
        const provPhoto = avatar ? avatar : '';
        const buttons = data && data?.length > 0 && !error && data.map((item, key) => {
            const time = item.time;
            const day = item.day;
            const timezone = showTimeZoneMessage && !isCentralTimeZone() ? getCentralDateWithFormat(new Date(), "z") : "";
            const displaytime = `${time} ${timezone}`;//: time;
            
            return (<button className="btn btn-primary" disabled={disabled} key={type + "_" + key + "_" + displaytime} onClick={(e) => { this.scheduleAppointment(e, item); }}>{displaytime}  |  {day}</button>);
        });

        if (hasMoreButton && buttons)
            buttons.push(<button className="btn btn-primary" onClick={(e) => { this.scheduleAppointment(e, data[0], hasMoreButton); }}  key={type+"_morebtn"}>MORE</button>); 

        return (
        <div className="col-12 videovisit-schedule-container" key={type}>
            {showMiniSpinner
                ? (
                    <div className="row">
                        <div className="col-12 align-self-center">
                            <MiniSpinner />
                        </div>
                    </div>
              ) : !error && providers && providers?.length > 0 ? ( 
                providers.map((providerData, key) => (
                    <React.Fragment 
                        key={type + "_" + key}
                    > 
                        {providerData && providerData.provider &&
                            <VideoVisitProviderCard
                                onClick={(e) => {
                                    this.scheduleAppointment(e, providerData, hasMoreButton);
                                }}
                                name={providerData.provider.displayName}
                                photo={providerData.provider.photoUrl || providerData.provider.photo}
                                specialty={providerData.provider.specialty}
                                scheduleDays={providerData?.scheduleDays}
                                getProviderSlots={(scheduleDays) => this.getProviderSlots(scheduleDays)}
                            />
                        } 
                    </React.Fragment> 
                ))
              ) : (
                <div className="row">
                  {data && data?.length > 0 && !error ? (
                    <React.Fragment>
                      <div className="col-12">
                        <div className="videovisit-schedule-provider">
                        <div className="row">
                            <div className="col-12">
                                <Typography
                                    type="body-03"
                                    color="$color-primary-a2"
                                    tag="h4"
                                    bold
                                >
                                    Next available times
                                </Typography>
                            </div>
                            <div className="col-12">
                                <div className="row">
                                    <div className="col item-avatar-container">
                                        <Thumbnail
                                            source={provPhoto}
                                            icon="doctor"
                                            size={"sm"}
                                        />
                                    </div>
                                    <div className="col item-details">
                                        <div className="row">
                                            <div className="col-12 item-name">
                                                <Typography
                                                    type="body-02"
                                                    color="$color-primary-a2"
                                                    bold>
                                                    {displayName}
                                                </Typography>
                                                <br />
                                                {specialty && (
                                                    <span className="item-specialty">
                                                        {specialty}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-12 videovisit-schedule-availability-btns"
                      >
                        {buttons}
                      </div>
                    </React.Fragment>
                  ) : (
                    <div
                        className={`col-12 no-times-available`}
                    > 
                        <Typography
                            type="meta-02"
                            color="$color-system-b1"
                        >
                        {errorMsg
                            ? errorMsg
                            : "Sorry, we're currently not able to display times."
                        }
                        </Typography>
                    </div>
                  )}
                </div>
              )}
          </div>
        );
    }

}

export default withRouter(VideoVisitAvailability);
